export const actionTypes = {
  REQUEST_START: 'PROFILE.PERSONAL_DATA_ADDRESS.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'PROFILE.PERSONAL_DATA_ADDRESS.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'PROFILE.PERSONAL_DATA_ADDRESS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROFILE.PERSONAL_DATA_ADDRESS.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
